// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { IsArray, IsInt, IsNotEmpty, ArrayNotEmpty, IsString, ValidateNested } from 'class-validator';

export class TemplateForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class PointLabelStyleForm {
  @IsString()
  @IsNotEmpty()
  name: string;

  @ArrayNotEmpty()
  @IsArray()
  @ValidateNested({ each: true })
  templates: TemplateForm[];
}
